import { v4 as uuidv4 } from 'uuid';

export function ProductSpecificationText(props) {
	return {
		componentName: 'ProductSpecificationText',
		componentId: uuidv4(),
		props: Object.assign(
			{
				mzSpecificationText: 'Modelo',
			},
			props,
		),
		childrenComponents: [],
	};
}
